/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface BroadcastMessage { 
    serviceProviderId?: string;
    senderId?: string;
    phoneNumbers?: string;
    textMessage?: string;
    smsRoute?: string;
    countryCode?: string;
    shouldNotPerformBalanceCheckKey?: string;
    country?: string;
    scheduleTime?: Date;
    referenceNumber?: string;
    deliveryStatus?: string;
    messageType?: string;
    performDnd?: boolean;
    performMnp?: boolean;
    performDuplicateCheck?: boolean;
    shouldNotPerformBalanceCheck: boolean;
    isWalletChecked?: boolean;
    smsChannel?: number;
}
